<template>
  <div class="sso-account">
    <span class="sso-account__label" v-html="`${$t('label')}:&nbsp;`" />
    <span class="sso-account__value">
      {{ account.email }}
    </span>
  </div>
</template>

<script>
export default {
  name: "SsoAccount",
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        label: "Enterprise Single-Sign-On (SSO)"
      },
      de: {
        label: "Enterprise Single-Sign-On (SSO)"
      }
    }
  }
}
</script>

<style lang="scss">
.sso-account {
  @include font-style(p);

  display: flex;
  flex-direction: column;

  margin-bottom: $spacing-32;

  &__label {
    @include font-style(h5, $color: $mid-grey);
  }

  &__label,
  &__value {
    @include media(max-width, m) {
      display: block;
    }
  }

  &__info-tooltip {
    margin-left: $base;
  }

  @include media(min-width, m) {
    flex-direction: row;
  }
}
</style>
